import Dropdown from "./Dropdown";
import { MenuItem } from "@mui/material";
import TextContainer from "./TextContainer";
import { Col, useIsMobile } from "./Flexbox";
import Text from "./Text";
import { Controller } from "react-hook-form";

//Short rows will keep the column width instead of stretching to fill the row, 
// being FIELD_MIN the narrowest value before reflowing to another line
const FIELD_MIN = '150px';
export const fieldRow = {display: 'grid', gridTemplateColumns: `repeat(auto-fit, minmax(${FIELD_MIN}, 1fr))`, gap: 16, alignItems: 'start'};

export const useRatioFieldRow = (...ratios) => {
    const isMobile = useIsMobile();
    return isMobile ? fieldRow : {...fieldRow, gridTemplateColumns: ratios.map(r => `minmax(0, ${r}fr)`).join(' '), gap: 0};
}
//Fields just fill the grid cell they're placed in
export const Input = ({theme, control, name, label, placeholder = "", prefix, suffix}) => (
    <Col style={{alignItems: 'start', minWidth: 0}}>
        <Text style={{marginBottom: 5}} color={theme.Black} size={15} weight={"medium"}>{label}</Text>
        <Controller name={name} control={control} render={({field: {onChange, value}, fieldState: {error}}) => (<TextContainer style={{width: '100%', height: 36}} prefix={prefix} suffix={suffix} theme={theme} placeHolder={placeholder} value={value} onChange={onChange} error={error}/>)}/>
    </Col>
)
export const SelectField = ({theme, control, name, label, options, multiple = false}) => (
    <Col style={{alignItems: 'start', minWidth: 0}}>
        <Text style={{marginBottom: 5}} color={theme.Black} size={15} weight={"medium"}>{label}</Text>
        <Controller name={name} control={control} render={({field: {onChange, value}, fieldState: {error}}) => (
            <Dropdown theme={theme}  value={value} multiple={multiple} onChange={onChange} style={{width: '100%', height: 36}} error={error}>
                {options.map(op => (
                    <MenuItem key={op.value} value={op.value}>{op.label}</MenuItem>
                ))}
            </Dropdown>
        )}/>
    </Col>
)